import { z } from 'zod';
import { QuestDTO, QuestDTOSchema } from '@hexcrawl/shared-utils';
import { requestJson } from '@/ui/services/api';

const QuestsResponseSchema = z.object({
  quests: z.array(QuestDTOSchema),
});

export const questService = {
  async getQuests(gameId: string, status?: 'active' | 'completed' | 'failed' | 'all'): Promise<QuestDTO[]> {
    const params = new URLSearchParams({ gameId });
    if (status) params.set('status', status);
    const response = await requestJson<{ quests: QuestDTO[] }>({
      url: `/game/quests?${params.toString()}`,
      method: 'GET',
      schema: QuestsResponseSchema,
    });
    return response.quests;
  },
};
